module.exports = __webpack_public_path__ + "img/theme-mark.f3b02f08.svg";